import { FC } from "react";
import { Routes, Route } from "react-router-dom";
import { BrokersGrid } from "../brokers/dataGrid";
import { CompletedBrokersGrid } from "../brokers/completedGrid";
import { Broker } from "../broker";
import { BrokerSignOff } from "../broker/signOff";
import { RequestNewBroker } from "../requestNew";
import { MyBrokerRequests } from "../myRequests";

type Props = {};

export const BrokersRoutes: FC<Props> = () => {
  return (
    <Routes>
      <Route path="broker/:id/signoff" element={<BrokerSignOff />} />
      <Route path="broker/:id/*" element={<Broker />} />
      <Route path="request-new" element={<RequestNewBroker />} />
      <Route path="my-requests" element={<MyBrokerRequests />} />
      <Route path="completed" element={<CompletedBrokersGrid />} />
      <Route path="/*" element={<BrokersGrid />} />
    </Routes>
  );
};
